var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vr360"},[_c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"vr360"},domProps:{"innerHTML":_vm._s(_vm.vr360)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }